// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1IPpd","isFlat":"Card_isFlat__2-0zV"};